import React, { useContext, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { PublicRoute } from './PublicRoute';
import { AuthRouter } from './AuthRouter';
import { PrivateRoute } from './PrivateRoute';
import { App } from './App';
import { AuthContext } from '../auth/AuthContext';
// import '../css/main.css';

export const AuthAdminRouter = () => {
    const { auth, verificaToken } = useContext(AuthContext);

    useEffect(() => {
        verificaToken();
    }, [verificaToken]);

    if (auth.checking) {
        return (
            <div role="status" className="space-y-2.5 animate-pulse max-w-lg">
                <span className="s">Loading...</span>
            </div>
        );
    }
    return (
        <div>
            <Routes>
                <Route
                    path="/auth/*"
                    element={
                        <PublicRoute isAuthenticated={auth.logged}>
                            <AuthRouter />
                        </PublicRoute>
                    }
                />
                <Route
                    path="*"
                    element={
                        <PrivateRoute isAuthenticated={auth.logged}>
                            <App />
                        </PrivateRoute>
                    }
                />
            </Routes>
        </div>
    );
};
